import { isArray } from 'lodash';

import { Shipment } from '../data/shipment.do';

export interface IDataWithShipmentList {
  shipmentList: Shipment[];
}

export function isDataWithShipmentList(value: unknown): value is IDataWithShipmentList {
  if (typeof value !== 'object' || value === null) {
    return false;
  }

  const list: unknown = (value as { shipmentList: unknown }).shipmentList;
  if (isArray(list)) {
    let isShipmentList: boolean = true;
    (list as any[]).forEach((listItem: unknown): void => {
      if (!(listItem instanceof Shipment)) {
        isShipmentList = false;
      }
    });

    return isShipmentList;
  }

  return false;
}
